<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [fieldTypeReplacements]="fieldTypeReplacements"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [entityId]="id"
                         formName="Create/Update Care Allowance Financial Year"
                         (onButtonClick)="buttonClicked($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onFilter)="filter($event)"
                         (onFormLoad)="formLoaded($event)"
                         (onModelChange)="modelChanged($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
